<div class="insurer-details-v2">
  @if (!first) {
    <img
      src="assets/image/protection-drivers.svg"
      alt=""
      class="icon-filter"
      style="height: 16px;"
      />
  }
  @if (first) {
    <img
      src="assets/image/protection-drivers.svg"
      alt=""
      class="icon-filter-cheapest"
      style="height: 16px;"
      />
  }
  <div class="label">
    {{ "comparison.protectionDriver" | translate }}:
  </div>
  <div class="insurer-details-v2__value">
    @switch (code) {
      @case ('GrabAXA') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Pacific') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('MSIG') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Pando') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('AXA') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Sompo') {
        <div>
          {{ "addOn.UnlimitedDrivers" | translate }}
        </div>
      }
      @case ('Takaful_Malaysia') {
        <div>
          {{ "addOn.UnlimitedDrivers" | translate }}
        </div>
      }
      @case ('Liberty') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Ikhlas') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Allianz') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Etiqa') {
        <div>
          {{ "addOn.UnlimitedDrivers" | translate }}
        </div>
      }
      @case ('Tune') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Zurich') {
        <div>
          @if (insuranceType === 'COM') {
            <span>
              1 {{ "common.driver" | translate | lowercase }}
            </span>
          }
          @if (insuranceType === 'TPFT') {
            <span>
              1 {{ "common.driver" | translate | lowercase }}
            </span>
          }
        </div>
      }
      @case ('RHB') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Kurnia') {
        <div>
          1 {{ "common.driver" | translate | lowercase }}
        </div>
      }
      @case ('Chubb') {
        <div>
          2 {{ "common.drivers" | translate | lowercase }}
        </div>
      }
    }
  </div>
</div>

@if (insuranceType && insuranceType !== 'TPFT') {
  <div
    class="insurer-details-v2"
    >
    @if (!first) {
      <img
        src="assets/image/towing-service.svg"
        alt=""
        class="icon-filter"
        style="height: 24px;"
        />
    }
    @if (first) {
      <img
        src="assets/image/towing-service.svg"
        alt=""
        class="icon-filter-cheapest"
        style="height: 24px;"
        />
    }
    <div class="label">
      {{ "insurerDetails.towingService" | translate }}
    </div>
    <div class="insurer-details-v2__value">
      @switch (code) {
        @case ('GrabAXA') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 30km
          </div>
        }
        @case ('Pacific') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 200
          </div>
        }
        @case ('MSIG') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 300
          </div>
        }
        @case ('Pando') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 350
          </div>
        }
        @case ('AXA') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 30km
          </div>
        }
        @case ('Sompo') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 300
          </div>
        }
        @case ('Takaful_Malaysia') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 50km
          </div>
        }
        @case ('Liberty') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 150km
          </div>
        }
        @case ('Ikhlas') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 100km
          </div>
        }
        @case ('Allianz') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 150km
          </div>
        }
        @case ('Etiqa') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 200
          </div>
        }
        @case ('Tune') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 200
          </div>
        }
        @case ('Zurich') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 200
          </div>
        }
        @case ('RHB') {
          <div>
            {{ "insurerDetails.upTo" | translate }} RM 300
          </div>
        }
        @case ('Kurnia') {
          <div>
            {{ "insurerDetails.upTo" | translate }} 150km
          </div>
        }
        @case ('Chubb') {
          <div>
            {{ "insurerDetails.unlimited24Hours" | translate }}
          </div>
        }
      }
    </div>
  </div>
}